import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, ValuesInterface } from "interface/rideCategory";
import { StatusInterface } from "interface/common";

export const rideCategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRideCategories: builder.query<
      ApiResponse,
      { [key: string]: string | number }
    >({
      query: (params) => ({
        url: API.GET_RIDE_CATEGORY,
        method: "GET",
        params,
      }),
      providesTags: ["VehicleCategory"],
    }),
    getRideCategoryList: builder.query<
      ApiResponse,
      { [key: string]: string | number } | void
    >({
      query: (params) => ({
        url: API.GET_RIDE_CATEGORY_LIST,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["VehicleCategory"],
    }),
    createVehicleCategory: builder.mutation<
      ApiResponse,
      { params: FormData | ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_RIDE_CATEGORY,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["VehicleCategory"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create ride category:", error);
        }
      },
    }),
    updateVehicleCategory: builder.mutation<
      ApiResponse,
      { params: FormData | ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_RIDE_CATEGORY,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["VehicleCategory"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update ride category:", error);
        }
      },
    }),
    updateVehicleCategoryStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_RIDE_CATEGORY}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["VehicleCategory"],
    }),
    deleteVehicleCategory: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_RIDE_CATEGORY}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["VehicleCategory"],
    }),
    bulkUpdateVehicleCategoryStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_RIDE_CATEGORY}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["VehicleCategory"],
    }),
    bulkDeleteRideCategories: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_RIDE_CATEGORY}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["VehicleCategory"],
    }),
  }),
});

export const {
  useGetRideCategoriesQuery,
  useGetRideCategoryListQuery,
  useCreateVehicleCategoryMutation,
  useUpdateVehicleCategoryMutation,
  useUpdateVehicleCategoryStatusMutation,
  useDeleteVehicleCategoryMutation,
  useBulkUpdateVehicleCategoryStatusMutation,
  useBulkDeleteRideCategoriesMutation,
} = rideCategoryApi;
